const ROOT = 'StepTwo/channelPublication/vignette';

export const FETCH_VIGNETTE_REQUEST = `${ROOT}/FETCH_VIGNETTE_REQUEST`;
export const FETCH_VIGNETTE_FAILURE = `${ROOT}/FETCH_VIGNETTE_FAILURE`;
export const FETCH_VIGNETTE_SUCCESS = `${ROOT}/FETCH_VIGNETTE_SUCCESS`;